import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex mt-12 w-full bg-[#DFE5E7] gap-[1px]" }
const _hoisted_2 = { class: "flex grow bg-white pl-12 pr-3" }
const _hoisted_3 = { class: "flex grow bg-white pr-12 pl-3" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import StatusBarLicenseInfo from '@/components/status-bar/components/status-bar-license-info.vue';
import { LicensePageQuery } from '@/graphql/codegen/generated/graphql';
import { computed, PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'licenseUsage',
  props: {
  licenseDetails: {
    required: true,
    type: Array as PropType<NonNullable<NonNullable<NonNullable<NonNullable<LicensePageQuery['ibManagerEntities']>['license']>['linux']>['licenseDetails']>>,
  },
},
  setup(__props) {

const props = __props

const serverCoresPackageType = 1;
const SUVMPackageType = 2;



const serverCoresDetails = computed(() => props.licenseDetails?.filter((item: any) => item?.packageType === serverCoresPackageType)[0]);
const SUVMDetails = computed(() => props.licenseDetails?.filter((item: any) => item?.packageType === SUVMPackageType)[0]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(StatusBarLicenseInfo, {
            "test-id": 'status-bar-info-server-cores',
            size: "large",
            title: "Server Cores",
            class: "grow flex",
            info: {
            assigned: _unref(serverCoresDetails)?.coresInUse || 0,
            available: (_unref(serverCoresDetails)?.packageNumCores || 0) - (_unref(serverCoresDetails)?.coresInUse || 0),
          }
          }, null, 8, ["info"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(StatusBarLicenseInfo, {
            "test-id": 'status-bar-info-suvm',
            size: "large",
            title: "SUVM Cores",
            class: "flex grow",
            info: {
            assigned: _unref(SUVMDetails)?.coresInUse || 0,
            available: (_unref(SUVMDetails)?.packageNumCores || 0) - (_unref(SUVMDetails)?.coresInUse || 0),
          }
          }, null, 8, ["info"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})